import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <header className="hero">
      <div className="hero-content">
        <h1>
          Clean Up Our Environment With
          <br />
          <span className="highlight">AI Waste Detector</span>
        </h1>

        <p className="subtitle">
          Every piece of waste matters. Detect it instantly, recycle it wisely,
          and protect the planet we share. Start building a cleaner future with
          AI today.
        </p>

        <a href="#detector" className="btn-start">
          Try the Detector <span className="arrow-right">→</span>
        </a>
      </div>

      <div className="hero-image-wrapper">
        <div className="image-box">
          <img
            src="https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80"
            alt="AI Waste Tech"
            className="model-img"
          />
          <div className="face-frame"></div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
